
/*
 *  Adds current url as a referrer attribute to user session links
 */
module.exports = Groupon.SharedJS.addReferrer = (function() {
  return {
    init: function() {
      var current_href, flags, ref1, referrer, selector;
      selector = '';
      flags = (ref1 = Groupon.PageFlags) != null ? ref1 : {};
      selector = flags.isTouch ? '#t-sign-in, #t-sign-out, .t-login-button' : '#ls-user-signin, #ls-user-signup, #sign-out';
      current_href = location.href;
      current_href = current_href.replace(location.hash, '');
      current_href = current_href.replace(/[?&](ref|return_to)=([^&]*)?/, '');
      referrer = 'return_to=' + encodeURIComponent(current_href);
      return $(selector).each(function() {
        var ref;
        ref = /\?/.test(this.href) ? '&' : '?';
        ref += referrer;
        return this.href += ref;
      });
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvc2hhcmVkL3VzZXJTZXNzaW9uQWRkUmVmZXJyZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvc2hhcmVkL3VzZXJTZXNzaW9uQWRkUmVmZXJyZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7O0FBR0EsTUFBTSxDQUFDLE9BQVAsR0FBaUIsT0FBTyxDQUFDLFFBQVEsQ0FBQyxXQUFqQixHQUFrQyxDQUFBLFNBQUE7U0FDakQ7SUFBQSxJQUFBLEVBQU0sU0FBQTtBQUNKLFVBQUE7TUFBQSxRQUFBLEdBQVc7TUFDWCxLQUFBLCtDQUE0QjtNQUU1QixRQUFBLEdBQ0ssS0FBSyxDQUFDLE9BQVQsR0FDRSwwQ0FERixHQUdFO01BRUosWUFBQSxHQUFlLFFBQVEsQ0FBQztNQUd4QixZQUFBLEdBQWUsWUFBWSxDQUFDLE9BQWIsQ0FBcUIsUUFBUSxDQUFDLElBQTlCLEVBQW9DLEVBQXBDO01BR2YsWUFBQSxHQUFlLFlBQVksQ0FBQyxPQUFiLENBQXFCLDhCQUFyQixFQUFxRCxFQUFyRDtNQUVmLFFBQUEsR0FBVyxZQUFBLEdBQWUsa0JBQUEsQ0FBbUIsWUFBbkI7YUFDMUIsQ0FBQSxDQUFFLFFBQUYsQ0FBVyxDQUFDLElBQVosQ0FBaUIsU0FBQTtBQUNmLFlBQUE7UUFBQSxHQUFBLEdBQVMsSUFBSSxDQUFDLElBQUwsQ0FBVSxJQUFDLENBQUEsSUFBWCxDQUFILEdBQXlCLEdBQXpCLEdBQWtDO1FBQ3hDLEdBQUEsSUFBTztlQUNQLElBQUMsQ0FBQSxJQUFELElBQVM7TUFITSxDQUFqQjtJQW5CSSxDQUFOOztBQURpRCxDQUFBLENBQUgsQ0FBQSJ9
